module.exports = __webpack_public_path__ + "static/aircraft-banner-carbon-e3a59e603c6f2622edd9f3e1f36a21f0.png";